import React, { ChangeEvent, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/ConfigureStore';
import { useAppSelector } from '../../store/hooks/StoreHooks';
import WellSurveyPlot1 from '../calculation-section/well-survey/WellSurveyPlot1';
import SizingSummary from './SizingSummary';
import { MainReport } from '../../store/model/calculations/MainReport';
import WellSurveyPlot2 from '../calculation-section/well-survey/WellSurveyPlot2';
interface IDeviationSurvey {
    ReportData?: any;
}

const DeviationSurvey: React.FC<IDeviationSurvey> = (  ReportData : any ) => {
    const equipmentForBelow = useAppSelector((state: RootState) => state.schematic.ESPEquipmentsForBelow);
    const wellSurveyData = useSelector((state: RootState) => state.wellSurvey.wellSurveyData);;
    const maxDls = wellSurveyData ? Math.max(...wellSurveyData.map((item: any) => item.dls || 0)) : 0;
    const maxMd = Math.max(...wellSurveyData.map((item:any) => item.md));
    const transitionZone = useAppSelector((state: RootState) => state.wellSurvey.TransitionZone ?? 0);
    const { schematicData } = useAppSelector(state => state?.calculations);
    const [selectedRow, setSelectedRow] = useState<any | null>(null);
    const lengthValue = equipmentForBelow?.[0]?.length ?? 0;
    const tailPipeBottom = useAppSelector((state: RootState) => state.wellSurvey.TailPipeBottom ?? 0);
    const tailPipeLength = useAppSelector((state: RootState) => state.wellSurvey.TailPipeLength ?? 0);
    const showWellDataInMainReport = useAppSelector((state: RootState) => state?.wellSurvey?.showWellDataInMainReport);
    const [reportInfo,setReportInfo]    = useState<any>(null);

    const surveyMetaData = {
        kop: useAppSelector((state: RootState) => state.wellSurvey.KOPOverride ?? 0),
        topOfEspPump: schematicData?.eoTubing ?? 0,
        bottomOfESPSensor: schematicData?.sensorDepth ?? 0,
        tailPipeDesander: ((lengthValue ?? 0) + (tailPipeLength ?? 0)),
        tailPipeBottom: tailPipeBottom ?? 0
    };
    const {
        projectName,
        caseName,
        contact,
        country,
        wellApiNo,
        represtative,
        equiment,
        formation,
        county,
        countyOther,
        customer,
        state,
        well,
        unitMeasurement
      } = useAppSelector((state) => state?.createProject);
    if (!wellSurveyData || !Array.isArray(wellSurveyData)) {
        return <p>No data available</p>; // Guard rendering
    }

    return (
       <>{showWellDataInMainReport && <div className="determine-widget-containers">
            <div className="header-main">
                <div className="flex flex-row justify-between">
                    <div>
                        <h3>DETERMINE deviation survey</h3>
                        <h5>Degree change and inclination of the wellbore.</h5>
                    </div>
                   
                </div>
            </div>
                <div className="flex flex-col gap-8 py-5 px-6 border-t border-dark mx-[200px]">
                    <div className="flex flex-col md:flex-row gap-8">
                        <div className="w-full md:w-1/3 gap-2 text-neutral-grey">
                            <div className="flex flex-col gap-2 text-neutral-grey border border-dark p-4 rounded-lg">
                                <div className="text-sm font-semibold">Deviation survey</div>
                                <div className='block'>
                                    <div className="flex flex-row gap-2 row-bottom-line justify-between items-center py-1 px-2">
                                        <label className="text-sm font-normal">KOP</label>

                                        <label className="text-sm font-normal flex-1 text-right">{ReportData?.ReportData?.KOP}</label>
                                    </div>
                                    <div className="flex flex-row gap-2 row-bottom-line justify-between items-center py-1 px-2">
                                        <label className="text-sm font-normal">Top of ESP pump</label>
                                        <label className="text-sm font-normal text-right flex-1">{ReportData?.ReportData?.TopOfEspPump}</label>
                                    </div>
                                    <div className="flex flex-row gap-2 row-bottom-line justify-between items-center py-1 px-2">
                                        <label className="text-sm font-normal">Bottom of ESP sensor</label>
                                        <label className="text-sm font-normal text-right flex-1">{ReportData?.ReportData?.BottomOfEspSensor}</label>
                                    </div>
                                    <div className="flex flex-row gap-2 row-bottom-line justify-between items-center py-1 px-2">
                                        <label className="text-sm font-normal">Max DLS above KOP</label>
                                        <label className="text-sm font-normal text-right flex-1">{ReportData?.ReportData?.MaxDLSAboveKOP}</label>
                                    </div>
                                    <div className="flex flex-row gap-2 row-bottom-line justify-between items-center py-1 px-2">
                                        <label className="text-sm font-normal">Depth of max DLS</label>
                                        <label className="text-sm font-normal text-right flex-1">{ReportData?.ReportData?.DepthOfMaxDLS}</label>
                                    </div>
                                    <div className="flex flex-row gap-2 row-bottom-line justify-between items-center py-1 px-2">
                                        <label className="text-sm font-normal">Casing size</label>
                                        <label className="text-sm font-normal text-right flex-1"> {ReportData?.ReportData?.Casing}</label>
                                    </div>
                                    <div className="flex flex-row gap-2 row-bottom-line justify-between items-center py-1 px-2">
                                        <label className="text-sm font-normal">Transition zone</label>
                                        <label className="text-sm font-normal text-right flex-1">{ReportData?.ReportData?.TransitionZone}</label>
                                    </div>
                                    <div className="flex flex-row gap-2 row-bottom-line justify-between items-center py-1 px-2">
                                        <label className="text-sm font-normal">ESP length</label>
                                        <label className="text-sm font-normal text-right flex-1">{ReportData?.ReportData?.EspLength}</label>
                                    </div>
                                    <div className="flex flex-row gap-2 row-bottom-line justify-between items-center py-1 px-2">
                                        <label className="text-sm font-normal">Tail pipe + desander</label>
                                        <label className="text-sm font-normal text-right flex-1">{ReportData?.ReportData?.TailPipeDesander}</label>
                                    </div>
                                    <div className="flex flex-row gap-2 row-bottom-line justify-between items-center py-1 px-2">
                                        <label className="text-sm font-normal">Tail pipe bottom</label>
                                        <label className="text-sm font-normal text-right flex-1">{ReportData?.ReportData?.TailPipeBtm}</label>
                                    </div>
                                    <div className="flex flex-row gap-2 row-bottom-line justify-between items-center py-1 px-2">
                                        <label className="text-sm font-normal">% tail pipe inside TZ</label>
                                        <label className="text-sm font-normal text-right flex-1">{ReportData?.ReportData?.TailPipeTZ}</label>
                                    </div>
                                    <div className="flex flex-row gap-2 justify-between items-center py-1 px-2">
                                        <label className="text-sm font-normal">Tubing size</label>
                                        <label className="text-sm font-normal text-right flex-1">{ReportData?.ReportData?.Tubing}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col gap-10 justify-center w-full md:w-2/3">
                        
                        <div className='text-neutral-25 font-bold mt-4' style={{ width:"750px", height:"900px" }}>
                           { wellSurveyData?.length > 0 &&
                            <WellSurveyPlot1 
                                   selectedRow={selectedRow}
                                   surveyData={wellSurveyData}
                                   maxDls={maxDls}
                                   maxMd={maxMd}
                                   customerName={customer?.toString()}
                                   wellName={well?.toString()}
                                   surveyMetaData={surveyMetaData}
                                   schematicData={schematicData ? {
                                       eoTubing: schematicData.eoTubing ?? 0,
                                       sensorDepth: schematicData.sensorDepth ?? 0
                                   } : null}
                                                                 />
                           }
                        </div>
                        <div className='text-neutral-25 font-bold mt-4' style={{ width:"750px", height:"900px" }}>
                           { wellSurveyData?.length > 0 &&
                            <WellSurveyPlot2 
                                   selectedRow={selectedRow}
                                   surveyData={wellSurveyData}
                                   maxDls={maxDls}
                                   maxMd={maxMd}
                                   customerName={customer?.toString()}
                                   wellName={well?.toString()}
                                   surveyMetaData={surveyMetaData}
                                   schematicData={schematicData ? {
                                       eoTubing: schematicData.eoTubing ?? 0,
                                       sensorDepth: schematicData.sensorDepth ?? 0
                                   } : null}
                                                                 />
                           }
                        </div>
                        </div>
                    </div>
                </div>
        </div>}
        </> 
    )
}

export default DeviationSurvey
